// Pure client-side filtering/sorting for the conversation tile list. The
// backend only supports filtering by `type` (see ConversationController),
// so search/level/isPublic are applied here once the list is fetched.

export function filterConversations(conversations, { search, level, isPublic } = {}) {
    const term = (search || "").trim().toLowerCase();

    return conversations.filter((conversation) => {
        if (term) {
            const haystack = `${conversation.name || ""} ${conversation.description || ""}`.toLowerCase();
            if (!haystack.includes(term)) return false;
        }

        if (level != null && level !== "" && conversation.level?.id !== level) {
            return false;
        }

        if (isPublic != null && isPublic !== "" && conversation.isPublic !== isPublic) {
            return false;
        }

        return true;
    });
}

export function sortConversations(conversations, sortKey) {
    const sorted = [...conversations];

    if (sortKey === "oldest") {
        sorted.reverse();
    } else if (sortKey === "name") {
        sorted.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    }
    // "newest" (default) is already the order the backend returns (most recent first).

    return sorted;
}
